module.exports = __webpack_public_path__ + "static/media/wave.f80a1886.png";